import React, { useState } from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';

import { RESIZE_URL } from 'utils/restapi';

import CommonSwapIcon from 'components/common/link-elements/CommonSwapIcon';
import MobileAppLinkPublishedCheckbox
  from 'components/dashboard/mobile-app-links/MobileAppLinkPublishedCheckbox';
import MobileAppDeleteIcon
  from 'components/dashboard/mobile-app-links/MobileAppDeleteIcon';
import MobileAppLinkEditForm
  from 'components/dashboard/mobile-app-links/MobileAppLinkEditForm';

import './MobileAppLinkItem.css';

const MobileAppLinkItem = props => {
  const { item, patchMobileAppsLinkSuccess } = props;
  const { t } = useTranslation();
  const [showCustomize, setShowCustomize] = useState(false);

  const _closeEditForm = () => {
    setShowCustomize(false);
  };

  return (
    <div className="mobile-app-link-item__component">
      <div
        className={`link-wrapper
          ${(patchMobileAppsLinkSuccess && patchMobileAppsLinkSuccess.id === item.id) ?
          ' pulse' : ''}`}
      >
        {!showCustomize &&
          <div className="link-info-wrapper">
            <div className="swap-icon-container">
              <CommonSwapIcon />
            </div>

            <div className="app-image-name">
              <div
                className={`app-image ${item.app_type}`}
                style={{ backgroundImage: item.thumbnail &&
                  `url(${RESIZE_URL}/cdn-cgi/image/f=auto,q=85,fit=crop,w=96/${item.thumbnail})` }}
              />
              <div className="app-name">
                {item.name}
              </div>
            </div>

            <div className="link-label">
              <div className={`icon ${item.app_type}`} />
              <div className="label">{item.app_type === 'ios' ? 'iOS' : 'Android'} {t("App")}</div>
            </div>

            <div
              className="customize-app-link"
              onClick={() => setShowCustomize(true) }
              role="button"
              tabIndex={-1}
            >
              {t("Customize App Link")}
            </div>

            <div className="actinons-block">
              <MobileAppLinkPublishedCheckbox
                linkId={item.id}
                isPublished={item.is_published}
              />
              <MobileAppDeleteIcon linkId={item.id} />
            </div>
          </div>
        }

        {/* Edit Form */}
        {showCustomize &&
          <MobileAppLinkEditForm
            item={item}
            closeEditForm={_closeEditForm}
          />
        }
      </div>
    </div>
  );
};

MobileAppLinkItem.propTypes = {
  item: PropTypes.object.isRequired,
  patchMobileAppsLinkSuccess: PropTypes.object,
};

MobileAppLinkItem.defaultProps = {
  patchMobileAppsLinkSuccess: null,
};

export default MobileAppLinkItem;
